function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["finect_error"],
  _excluded2 = ["actions", "component", "notLoggedInComponent", "withErrorView", "level", "user", "profile", "path", "from"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import React from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { finectAPI } from '@finect/front-utils/finectAPI';
import { isBrowser } from '@finect/front-utils/isBrowser';
import { bindActionCreators } from 'redux';
import { getBaseURL } from '@finect/front-utils/env';
import { LoginRedirect } from './LoginRedirect';
import { ErrorView } from './ErrorView';
export function setUserProfileFetchingStatus(fetching, fetched) {
  return {
    type: 'SET_USER_PROFILE_FETCHING_STATUS',
    fetching: fetching,
    fetched: fetched
  };
}
export function setUserProfile(profile) {
  return {
    type: 'SET_USER_PROFILE',
    profile: profile
  };
}
export function setUserProfileError(error) {
  return {
    type: 'SET_USER_PROFILE_ERROR',
    error: error
  };
}
export function getUserProfile(referrer, cookie) {
  var headers = {
    'x-referrer': referrer ? referrer : getBaseURL()
  };
  if (!isBrowser()) headers.redirect = 'manual';
  return function (dispatch) {
    return Promise.all([dispatch(setUserProfileFetchingStatus(true, true))]).then(function () {
      return finectAPI({
        version: 'v4',
        path: 'users/me/profile',
        method: 'GET',
        credentials: cookie,
        headers: headers,
        onSuccess: function onSuccess(_ref) {
          var data = _ref.data,
            code = _ref.code;
          if ([200].includes(code)) {
            return dispatch(setUserProfile(data));
          }
          if ([302].includes(code)) {
            return dispatch(setUserProfileError({
              status: code,
              location: data.location
            }));
          }
        },
        onError: function onError(data) {
          var finect_error = data.finect_error,
            error = _objectWithoutProperties(data, _excluded);
          return dispatch(setUserProfileError(error));
        }
      });
    });
  };
}
var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user.user,
    profile: state.user.profile
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      getUserProfile: getUserProfile
    }, dispatch)
  };
};
var PrivateRoute = function PrivateRoute(_ref2) {
  var actions = _ref2.actions,
    Scene = _ref2.component,
    NotLoggedInComponent = _ref2.notLoggedInComponent,
    _ref2$withErrorView = _ref2.withErrorView,
    withErrorView = _ref2$withErrorView === void 0 ? false : _ref2$withErrorView,
    _ref2$level = _ref2.level,
    level = _ref2$level === void 0 ? 'soft' : _ref2$level,
    user = _ref2.user,
    profile = _ref2.profile,
    path = _ref2.path,
    from = _ref2.from,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  var _user$isLoggedIn = user.isLoggedIn,
    isLoggedIn = _user$isLoggedIn === void 0 ? false : _user$isLoggedIn;
  var isHardLogged = profile.fetched && !profile.fetching && profile.model;
  var hardLoginLocation = profile.error && profile.error.location && [302].includes(profile.error.status) ? profile.error.location : null;
  var status = ['hard'].includes(level) && !isHardLogged && profile.error ? profile.error.status : isLoggedIn ? 200 : 401;
  return React.createElement(Route, _extends({}, rest, {
    render: function render(props) {
      var url = props && props.match && props.match.url ? props.match.url : null;
      var RenderComponent = function (_React$Component) {
        _inherits(RenderComponent, _React$Component);
        var _super = _createSuper(RenderComponent);
        function RenderComponent() {
          _classCallCheck(this, RenderComponent);
          return _super.apply(this, arguments);
        }
        _createClass(RenderComponent, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            if (['hard'].includes(level) && !profile.fetched) {
              actions.getUserProfile(window.location.href, null);
            }
          }
        }, {
          key: "render",
          value: function render() {
            if (['hard'].includes(level) && (!profile.fetched || profile.fetching)) {
              return null;
            }
            if (['soft'].includes(level) && user.isLoggedIn || ['hard'].includes(level) && isHardLogged) {
              return React.createElement(Scene, props);
            }
            if (NotLoggedInComponent) {
              return React.createElement(NotLoggedInComponent, props);
            }
            if (withErrorView) {
              return React.createElement(ErrorView, _extends({
                statusCode: status,
                actionPath: null,
                actionText: null
              }, props));
            }
            return React.createElement(LoginRedirect, _extends({
              to: hardLoginLocation,
              from: from || url || path
            }, props));
          }
        }]);
        return RenderComponent;
      }(React.Component);
      return React.createElement(RenderComponent, null);
    }
  }));
};
PrivateRoute.loadInitialData = function (appStore, cookie, match, params, location) {
  var referrer = "".concat(getBaseURL()).concat(location);
  return appStore.dispatch(getUserProfile(referrer, cookie));
};
export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);